import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, validateYupSchema } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./DeliveryForm.css"; // Import your CSS file
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import GeneralApiService from "../../services/generalServices";
const DynamicFormikForm = ({
  fields,
  optionsData,
  submitLabel = "Submit",
  onSubmit,
}) => {
  const generalServices = new GeneralApiService();
  const navigate = useNavigate();
  const {
    enquirySourceList,
    primarySourceList,
    districtList,
    talukaList,
    villageList,
    branchesList,
    banklist,
    paymentList,
    cashOptions,
    makeList,
    modelList,
    yearsList,
    dspList,
    conditionType,
    categoryId,
  } = optionsData;
  const [renderedFields, setRenderedFields] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [options, setOptions] = useState({
    districtList: districtList,
    talukaList: [],
    villageList: [],
    manufatureList: makeList,
    newModalList: modelList,
    dspList: dspList,
    oldMakeList: makeList,
    oldModelList: modelList,
    yearsList: yearsList,
    primarySourceList: primarySourceList,
    enquirySourceList: [],
    conditionType: conditionType,
    paymentMethodList: paymentList,
    paymentDetail: cashOptions,
    banklist: banklist,
    branchesList: branchesList,
  });
  const validationSchema = Yup.object().shape({
    // Branch Details
    branchId: Yup.string().required("Branch is required"),

    // Personal Details
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().required("Email is required"),
    mobileNumber: Yup.string().required("Mobile number is required"),
    whatsappNumber: Yup.string().required("Whatsapp number is required"),

    // Area Details
    district: Yup.string().required("District is required"),
    taluko: Yup.string().required("Taluka is required"),
    village: Yup.string().required("Village is required"),
    dsp: Yup.string().required("Salesperson is required"),

    // New Product Details
    manufature: Yup.string().required("Manufature is required"),
    modal: Yup.string().required("Model is required"),
    engineNumber: Yup.string().required("Engine number is required"),
    chasisNumber: Yup.string().required("Chasis number is required"),
    year: Yup.string().required("Year is required"),
    hour: Yup.string().required("Hour is required"),
    newPrice: Yup.string().required("New price is required"),

    // Old Product Details
    isOldOwned: Yup.boolean(),
    oldmake: Yup.string().when("isOldOwned", {
      is: true, // Only required if isOldOwned is true
      then: (schema) => schema.required("Old Make is required"),
      otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
    }),
    oldmodel: Yup.string().when("isOldOwned", {
      is: true, // Only required if isOldOwned is true
      then: (schema) => schema.required("Old Model is required"),
      otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
    }),
    oldyear: Yup.string().when("isOldOwned", {
      is: true, // Only required if isOldOwned is true
      then: (schema) => schema.required("Old Year is required"),
      otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
    }),
    oldPrice: Yup.string().when("isOldOwned", {
      is: true,
      then: (schema) => schema.required("Old Price is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    oldCondition: Yup.string().when("isOldOwned", {
      is: true,
      then: (schema) => schema.required("Old Condition is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    totalHours: Yup.string().when("isOldOwned", {
      is: true, // Only required if isOldOwned is true
      then: (schema) => schema.required("Total hours is required"),
      otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
    }),
    tractorNo: Yup.string().when("isOldOwned", {
      is: true, // Only required if isOldOwned is true
      then: (schema) => schema.required("Tractor No is required"),
      otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
    }),

    // Bank Details
    paymentMethod: Yup.string().required("Payment method is required"),
    paymentDetail: Yup.string(),
    remainingPrice: Yup.string(),

    // Enquiry Details
    primarySource: Yup.string().required("Primary Source is required"),
    enquirySource: Yup.string().required("Enquiry Source is required"),

    // Support Detail
    enquiryDate: Yup.date().required("Enquiry date is required"),
    deliveryDate: Yup.date().required("Delivery date is required"),
    createdby: Yup.string().required("Created By is required"),
    farmName: Yup.string().required("Farm name is required"),
    outletContact: Yup.string().required("Showroom name is required"),
  });

  const [initialValues, setInitialValues] = useState({
    // Branch Details
    branchId: "",

    // Personal Details
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    whatsappNumber: "",

    // Area Details
    state: "",
    district: "",
    taluko: "",
    village: "",
    dsp: "",

    // New Product Details
    manufature: 2,
    modal: "",
    engineNumber: "",
    chasisNumber: "",
    year: "",
    hour: "",
    newPrice: "",

    // Old Product Details
    isOldOwned: false, // Default to false, adjust as needed
    oldmake: "",
    oldmodel: "",
    oldyear: "",
    oldPrice: "",
    oldCondition: "",
    totalHours: "",
    tractorNo: "",

    // Bank Details
    paymentMethod: "Cash", // This can be 'Cash' or 'Loan'
    paymentDetail: "", // Only required if paymentMethod is 'Cash'

    // Enquiry Details
    primarySource: "",
    enquirySource: "",

    // Support Detail
    enquiryDate: "",
    deliveryDate: "",
    createdby: "",
    remainingPrice: "",
    ssp: "",
    farmName: "",
    remarks: "",
    wARK: "",
  });

  useEffect(() => {
    let parsedCustomFields = {};
    if (optionsData.editData?.custom_fields) {
      try {
        const raw = optionsData.editData.custom_fields;
        parsedCustomFields =
          typeof raw === "string" ? JSON.parse(raw) : raw || {};
        setRenderedFields((prev) => ({ ...prev, ...parsedCustomFields }));
      } catch (error) {
        console.error("Invalid JSON in custom_fields:", error);
      }
    }
    const sspMode = optionsData.sspEditMode === true;
    const support = parsedCustomFields.support_info || {};
    const enqDet = parsedCustomFields.enquiry_detail || {};
    const oldProd = parsedCustomFields.old_product || {};
    setInitialValues({
      // Branch Details
      branchId: optionsData.customerData?.branch_id || "",

      // Personal Details
      firstName: optionsData.editData?.first_name || "",
      lastName: optionsData.editData?.last_name || "",
      email: optionsData.editData?.email || "",
      mobileNumber: optionsData.editData?.phone_number || "",
      whatsappNumber: optionsData.editData?.whatsapp_number || "",

      // Area Details
      state: "",
      district: String(optionsData.customerData?.district ?? ""),
      taluko: String(optionsData.customerData?.taluka ?? ""),
      village: String(optionsData.customerData?.village ?? ""),
      dsp: String(optionsData.customerData?.salesperson_id ?? ""),

      // New Product Details
      manufature: String(optionsData.customerData?.manufacture ?? ""),
      modal: String(optionsData.customerData?.modal_id ?? ""),
      engineNumber: parsedCustomFields.oldEngineNo || "",
      chasisNumber: parsedCustomFields.oldChassis || "",
      year: String(optionsData.customerData?.oldyear ?? ""),
      hour: String(optionsData.customerData?.total_hours ?? ""),
      newPrice: optionsData.customerData?.newPrice || "",

      // Old Product Details
      isOldOwned: sspMode
        ? !!oldProd.is_old_owned
        : optionsData.customerData?.old_tractor === "Yes",
      oldmake: sspMode
        ? String(oldProd.old_make ?? "")
        : String(optionsData.customerData?.oldmake ?? ""),
      oldmodel: sspMode
        ? String(oldProd.old_model ?? "")
        : String(optionsData.customerData?.oldmodel ?? ""),
      oldyear: sspMode
        ? String(oldProd.old_year ?? "")
        : String(optionsData.customerData?.oldyear ?? ""),
      oldPrice: sspMode
        ? String(oldProd.old_price ?? "")
        : String(optionsData.customerData?.oldPrice ?? ""),
      oldCondition: optionsData.customerData?.oldCondition || "",
      totalHours: String(optionsData.customerData?.total_hours ?? ""),
      tractorNo: optionsData.customerData?.tractor_no || "",

      // Bank Details
      paymentMethod: optionsData.customerData?.paymentMode || "", // This can be 'Cash' or 'Loan'
      paymentDetail: optionsData.customerData?.paymentDetails || "", // Only required if paymentMethod is 'Cash'

      // Enquiry Details
      primarySource: sspMode
        ? String(enqDet.primary_source ?? "")
        : String(optionsData.customerData?.primary_source_id ?? ""),
      enquirySource: sspMode
        ? String(enqDet.enquiry_source ?? "")
        : String(optionsData.customerData?.enquiry_source_id ?? ""),

      // Support Detail
      enquiryDate:
        optionsData.editData?.enquiry_date &&
        moment(optionsData.editData.enquiry_date).isValid()
          ? moment(optionsData.editData.enquiry_date).format("YYYY-MM-DD")
          : "",
      deliveryDate:
        optionsData.editData?.delivery_date &&
        moment(optionsData.editData.delivery_date).isValid()
          ? moment(optionsData.editData.delivery_date).format("YYYY-MM-DD")
          : "",
      createdby: "",
      remainingPrice: optionsData.customerData?.remainingPrice || "",
      farmName: sspMode ? String(support.farm_name ?? "") : "",
      remarks: sspMode ? String(support.remarks ?? "") : "",
      wARK: sspMode ? String(support.wark ?? "") : "",
      ssp:
        parsedCustomFields.ssp_id != null && parsedCustomFields.ssp_id !== ""
          ? String(parsedCustomFields.ssp_id)
          : "",
    });
    setOptions((preVal) => ({
      ...preVal,
      newModalList: modelList.filter(
        (val) =>
          val.manufacturerId ==
          (optionsData.customerData?.manufacture ?? optionsData.customerData?.oldmake ?? 2)
      ),
      talukaList: talukaList.filter(
        (val) => val.district_id == optionsData.customerData?.district
      ),
      villageList: villageList.filter(
        (val) => val.taluka_id == optionsData.customerData?.taluka
      ),
      oldModelList: modelList.filter(
        (val) => val.manufacturerId == optionsData.customerData?.oldmake
      ),
      enquirySourceList: enquirySourceList.filter((val) =>
        sspMode
          ? String(val.primary_source_id) === String(enqDet.primary_source)
          : val.primary_source_id == optionsData.customerData?.primary_source_id
      ),
    }));
    if (!optionsData.customerData) {
      setOptions((preVal) => ({
        ...preVal,
        newModalList: modelList.filter((val) => val.manufacturerId == 2),
      }));
    }

    // if (optionsData.editData?.custom_fields) {
    //   try {
    //     const parsedCustomFields = JSON.parse(
    //       optionsData.editData?.custom_fields
    //     );
    //     setRenderedFields((prev) => ({ ...prev, ...parsedCustomFields }));
    //   } catch (error) {
    //     console.error("Invalid JSON in custom_fields:", error);
    //   }
    // }
  }, [optionsData]);

  const submitHandler = async (values) => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const mergedCustomFields = {
      ...renderedFields,
      ...(values.ssp != null && values.ssp !== ""
        ? { ssp_id: String(values.ssp) }
        : {}),
    };
    const customFields = Object.fromEntries(
      Object.entries(mergedCustomFields).filter(
        ([key, value]) =>
          !(key === "ssp_id" && (value === null || value === ""))
      )
    );
    const finalValues = {
      ...values,
      customFields,
    };
    try {
      await onSubmit(finalValues);
    } catch (error) {
      console.error("Submission failed:", error);
      setIsSubmitting(false);
      return;
    }
    setTimeout(() => setIsSubmitting(false), 3000);
  };

  const DropdownField = ({
    item,
    values,
    options,
    handleDropdownChange,
    optionList,
  }) => (
    <Col md={4} key={item.name}>
      <label htmlFor={item.name} className="form-label">
        {item.label}
      </label>
      <Field
        as="select"
        name={item.name}
        className="form-control form-select"
        value={values[item.name] || ""}
        onChange={(e) => handleDropdownChange(item.name, e.target.value)}
      >
        <option value="" disabled>{`Select ${item.label}`}</option>
        {optionList.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Field>
      <ErrorMessage
        name={item.name}
        component={({ children }) => (
          <span style={{ color: "darkred", fontSize: "0.875rem" }}>
            {children}
          </span>
        )}
      />
    </Col>
  );

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
      }) => {

        console.log("SSP OPTIONS:", optionsData?.sspOptions);
        const handleDropdownChange = async (fieldName, selectedValue) => {
          setFieldValue(fieldName, selectedValue);

          switch (fieldName) {
            case "district":
              setOptions((preVal) => ({
                ...preVal,
                talukaList: talukaList.filter(
                  (val) => val.district_id == selectedValue
                ),
              }));
              setFieldValue("taluko", "");
              setFieldValue("village", "");
              break;

            case "taluko":
              setOptions((preVal) => ({
                ...preVal,
                villageList: villageList.filter(
                  (val) => val.taluka_id == selectedValue
                ),
              }));
              setFieldValue("village", "");
              break;

            case "village":
              if (selectedValue) {
                try {
                  const response = await generalServices.getAreaAssignedPerson(
                    categoryId,
                    selectedValue
                  );
                  if (response.result.length > 0) {
                    setFieldValue("dsp", response.result[0].id);
                  }
                } catch (error) {
                  console.error("Error fetching area assigned person:", error);
                }
              }
              break;

            case "manufature":
              setOptions((preVal) => ({
                ...preVal,
                newModalList: modelList.filter(
                  (val) => val.manufacturerId == selectedValue
                ),
              }));
              setFieldValue("modal", "");
              break;

            case "oldmake":
              setOptions((preVal) => ({
                ...preVal,
                oldModelList: modelList.filter(
                  (val) => val.manufacturerId == selectedValue
                ),
              }));
              setFieldValue("oldmodel", "");
              break;

            case "primarySource":
              setOptions((preVal) => ({
                ...preVal,
                enquirySourceList: enquirySourceList.filter(
                  (val) => val.primary_source_id == selectedValue
                ),
              }));
              setFieldValue("enquirySource", "");
              break;


            default:
              break;
          }
        };
        const handleFieldChange = (name, value) => {
          setRenderedFields((prevState) => ({
            ...prevState,
            [name]: value, // Track the updated value of the field
          }));
        };
        return (
          <Form>
            <Row>
              {fields.length > 0 &&
                fields.map((category, index) => {
                  return (
                    <Col
                      md={12}
                      key={`${category.main_field_name}-${index}`}
                      className="mb-1"
                    >
                      <h9 className="category-title mt-2 fw-bold">
                        {category.main_field_name}
                      </h9>
                      <Row className="mb-1">
                        {category.fields.map((item, itemIndex) => {
                          switch (item.name) {
                            case "branchId":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={{ list: branchesList }}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={branchesList}
                                />
                              );

                            case "firstName":
                            case "lastName":
                            case "email":
                            case "whatsappNumber":
                            case "mobileNumber":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "district":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={options}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.districtList}
                                />
                              );

                            case "taluko":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={options}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.talukaList}
                                />
                              );

                            case "village":
                              return (
                                <DropdownField
                                  item={item}
                                  itemIndex={itemIndex}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.villageList}
                                />
                              );

                            case "dsp":
                              return (
                                <DropdownField
                                  item={item}
                                  itemIndex={itemIndex}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.dspList}
                                />
                              );
                            case "ssp":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={optionsData?.sspOptions || []}
                                />
                              );

                            case "manufature":
                              return (
                                <DropdownField
                                  item={item}
                                  itemIndex={itemIndex}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.manufatureList}
                                />
                              );

                            case "modal":
                              return (
                                <DropdownField
                                  item={item}
                                  itemIndex={itemIndex}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.newModalList}
                                />
                              );

                            case "engineNumber":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "chasisNumber":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "year":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.yearsList}
                                />
                              );

                            case "hour":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "newPrice":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "isOldOwned":
                              return (
                                <Col md={12} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <Field
                                      type="checkbox"
                                      name={item.name}
                                      className="form-check-input"
                                      checked={values[item.name] || false} // If not checked, defaults to false
                                      onChange={handleChange} // Updates Formik's state
                                    />
                                    <label
                                      className="form-check-label ms-1"
                                      htmlFor={item.name}
                                    >
                                      {item.label}
                                    </label>
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "oldmake":
                              return (
                                values["isOldOwned"] && (
                                  <DropdownField
                                    item={item}
                                    values={values}
                                    handleDropdownChange={handleDropdownChange}
                                    optionList={options.oldMakeList}
                                  />
                                )
                              );
                            case "oldmodel":
                              return (
                                values["isOldOwned"] && (
                                  <DropdownField
                                    item={item}
                                    values={values}
                                    handleDropdownChange={handleDropdownChange}
                                    optionList={options.oldModelList}
                                  />
                                )
                              );

                            case "oldyear":
                              return (
                                values["isOldOwned"] && (
                                  <DropdownField
                                    item={item}
                                    values={values}
                                    handleDropdownChange={handleDropdownChange}
                                    optionList={options.yearsList}
                                  />
                                )
                              );

                            case "oldCondition":
                              return (
                                values["isOldOwned"] && (
                                  <DropdownField
                                    item={item}
                                    values={values}
                                    handleDropdownChange={handleDropdownChange}
                                    optionList={options.conditionType}
                                  />
                                )
                              );

                            case "oldPrice":
                              return (
                                values["isOldOwned"] && (
                                  <Col md={4} key={`${item.name}-${itemIndex}`}>
                                    <div style={{ marginBottom: "1rem" }}>
                                      <label
                                        htmlFor={item.name}
                                        className="form-label"
                                      >
                                        {item.label}
                                      </label>
                                      <input
                                        id={item.name}
                                        name={item.name}
                                        type="text"
                                        className="form-control"
                                        placeholder={`Enter ${item.label}`}
                                        value={values[item.name]} // Controlled input
                                        onChange={handleChange} // Formik's handleChange handles input value updates
                                        onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                      />
                                      {touched[item.name] &&
                                        errors[item.name] && (
                                          <span
                                            style={{
                                              color: "darkred",
                                              fontSize: "0.875rem",

                                              display: "block",
                                            }}
                                          >
                                            {errors[item.name]}
                                          </span>
                                        )}
                                    </div>
                                  </Col>
                                )
                              );

                            case "totalHours":
                              return (
                                values["isOldOwned"] && (
                                  <Col md={4} key={`${item.name}-${itemIndex}`}>
                                    <div style={{ marginBottom: "1rem" }}>
                                      <label
                                        htmlFor={item.name}
                                        className="form-label"
                                      >
                                        {item.label}
                                      </label>
                                      <input
                                        id={item.name}
                                        name={item.name}
                                        type="text"
                                        className="form-control"
                                        placeholder={`Enter ${item.label}`}
                                        value={values[item.name]} // Controlled input
                                        onChange={handleChange} // Formik's handleChange handles input value updates
                                        onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                      />
                                      {touched[item.name] &&
                                        errors[item.name] && (
                                          <span
                                            style={{
                                              color: "darkred",
                                              fontSize: "0.875rem",

                                              display: "block",
                                            }}
                                          >
                                            {errors[item.name]}
                                          </span>
                                        )}
                                    </div>
                                  </Col>
                                )
                              );

                            case "tractorNo":
                              return (
                                values["isOldOwned"] && (
                                  <Col md={4} key={`${item.name}-${itemIndex}`}>
                                    <div style={{ marginBottom: "1rem" }}>
                                      <label
                                        htmlFor={item.name}
                                        className="form-label"
                                      >
                                        {item.label}
                                      </label>
                                      <input
                                        id={item.name}
                                        name={item.name}
                                        type="text"
                                        className="form-control"
                                        placeholder={`Enter ${item.label}`}
                                        value={values[item.name]} // Controlled input
                                        onChange={handleChange} // Formik's handleChange handles input value updates
                                        onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                      />
                                      {touched[item.name] &&
                                        errors[item.name] && (
                                          <span
                                            style={{
                                              color: "darkred",
                                              fontSize: "0.875rem",

                                              display: "block",
                                            }}
                                          >
                                            {errors[item.name]}
                                          </span>
                                        )}
                                    </div>
                                  </Col>
                                )
                              );

                            case "paymentMethod":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={options}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.paymentMethodList}
                                />
                              );

                            case "paymentDetail":
                              return (
                                <>
                                  {values["paymentMethod"] === "Cash" && (
                                    <DropdownField
                                      item={item}
                                      values={values}
                                      options={options}
                                      handleDropdownChange={
                                        handleDropdownChange
                                      }
                                      optionList={options.paymentDetail}
                                    />
                                  )}
                                  {values["paymentMethod"] === "Loan" && (
                                    <DropdownField
                                      item={item}
                                      values={values}
                                      options={options}
                                      handleDropdownChange={
                                        handleDropdownChange
                                      }
                                      optionList={options.banklist}
                                    />
                                  )}
                                </>
                              );

                            case "remainingPrice":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={values[item.name]} // Controlled input
                                      onChange={handleChange} // Formik's handleChange handles input value updates
                                      onBlur={handleBlur} // Formik's handleBlur handles touch state updates
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            case "primarySource":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={options}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.primarySourceList}
                                />
                              );

                            case "enquirySource":
                              return (
                                <DropdownField
                                  item={item}
                                  values={values}
                                  options={options}
                                  handleDropdownChange={handleDropdownChange}
                                  optionList={options.enquirySourceList}
                                />
                              );

                            case "enquiryDate":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <Field
                                      type="date"
                                      name={item.name}
                                      className="form-control"
                                      value={values[item.name] || ""} // Default to empty string if undefined
                                      onChange={(e) =>
                                        handleChange(item.name)(e)
                                      }
                                      onBlur={() => handleBlur(item.name)}
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );
                            case "deliveryDate":
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <Field
                                      type="date"
                                      name={item.name}
                                      className="form-control"
                                      value={values[item.name] || ""} // Default to empty string if undefined
                                      onChange={(e) =>
                                        handleChange(item.name)(e)
                                      }
                                      onBlur={() => handleBlur(item.name)}
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );

                            default:
                              return (
                                <Col md={4} key={`${item.name}-${itemIndex}`}>
                                  <div style={{ marginBottom: "1rem" }}>
                                    <label
                                      htmlFor={item.name}
                                      className="form-label"
                                    >
                                      {item.label}
                                    </label>
                                    <input
                                      id={item.name}
                                      name={item.name}
                                      type="text"
                                      className="form-control"
                                      placeholder={`Enter ${item.label}`}
                                      value={
                                        values[item.name] ||
                                        renderedFields[item.name]
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                        handleFieldChange(
                                          item.name,
                                          e.target.value
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                    {touched[item.name] &&
                                      errors[item.name] && (
                                        <span
                                          style={{
                                            color: "darkred",
                                            fontSize: "0.875rem",
                                            display: "block",
                                          }}
                                        >
                                          {errors[item.name]}
                                        </span>
                                      )}
                                  </div>
                                </Col>
                              );
                          }
                        })}

                      </Row>
                    </Col>
                  );
                })}
            </Row>
            {/* Save Changes */}
            <Row className="mb-2">
              <Col md={12}>
                <Button
                  variant="outline-primary"
                  className="px-5"
                  onClick={() => {
                    submitHandler(values);
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : submitLabel}
                </Button>

                <Button
                  variant="outline-primary"
                  className=" ms-2 px-4"
                  onClick={() => {
                    navigate(-1);
                  }}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default DynamicFormikForm;
